import React, { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-number-input';
// import Country from 'country-flags-dial-code'
import Country from 'country-list-with-dial-code-and-flag';
import { Input } from 'reactstrap';
import CountryCodeDropDown from '../dropdown/country-code-dropdown';
import { Button, Tooltip } from 'antd';

export const ReactPhone = ({
  handleInput,
  selectedCountry,
  setSelectCountry,
  inputNumber,
  onEnterPress,
}) => {
  const [value, setValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [countryList, setCountryList] = useState({});
  const [countryCodeList, setCountryCodeList] = useState([]);
  const countryLists = [
    {
      code: 'GB',
      dial_code: '+44',
      flag: '🇬🇧',
      name: 'United Kingdom',
      preferred: true,
    },
    {
      code: 'IN',
      dial_code: '+91',
      flag: '🇮🇳',
      name: 'India',
      preferred: true,
    },
    {
      code: 'UA',
      dial_code: '+380',
      flag: '🇺🇦',
      name: 'Ukraine',
    },
  ];

  const toggle = () => setIsOpen(!isOpen);
  const handleSelect = (type) => {
    setSelectCountry(type);
  };
  return (
    <div className='login-input relative' style={{ marginBottom: '4px' }}>
       <Input
        type="tel"
        className='form-input border text-base text-[#0F0F0F] border-[#DEE2E6] focus:border-[#DEE2E6] rounded-lg w-full py-4 pr-4 pl-14 placeholder-[#ADB5BD]'
        placeholder='Phone number'
        onChange={(e) => {
          let invalidChars = ['-', '+', 'e'];
          if (invalidChars.includes(e.target.value)) {
            e.preventDefault();
          } else {
            handleInput(e);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && onEnterPress) {
            e.preventDefault();
            onEnterPress();
          }
        }}
        value={inputNumber}
      />
      <span className="form-input-text text-base text-[#0F0F0F] absolute left-4 top-4">+44</span>
      {/* <div className='form-input-text text-base text-[#0F0F0F] absolute left-4 top-4'>
        <CountryCodeDropDown
            className="form-input-text text-base text-[#0F0F0F] absolute left-4 top-4"
            Country={countryLists.sort((a, b) => a.dial_code - b.dial_code)}
            toggle={toggle}
            isOpen={isOpen}
            selectedCountry={selectedCountry}
            handleSelect={handleSelect}
        />
      </div>       */}
    </div>
  );
};
export default ReactPhone;
